import Head from 'next/head';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { basePath, withBasePath } from '@/utils/basePath';

export interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  noindex?: boolean;
  keywords?: string;
}

const SEO = ({
  title = 'Logiciel Facturation Avocat : Solution de gestion cabinets d’avocats',
  description = 'Logiciel avocat intuitif, simple, et complet pour la gestion du cabinet | zLawyer aide les avocats, depuis 2006, à ne plus perdre de temps... à en saisir.',
  image = withBasePath('/ogImage.webp'),
  url = 'https://www.zlawyer.fr/logiciel-avocats/',
  type = 'website',
  noindex = false,
  keywords,
}: SEOProps) => {
  const { asPath } = useRouter();
  const resolvedKeywords = keywords || 'logiciel avocat cabinet facturation';
  const resolvedUrl = url || `https://www.zlawyer.fr${asPath}`;
  const resolvedImage = image.startsWith('http') ? image : `https://www.zlawyer.fr${image}`;

  return (
    <>
    <Head>
      <title>{title}</title>
      <meta content="fr" name="language" />
      <meta content="fr" httpEquiv="content-language" />
      <meta charSet="utf-8" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta content={description} name="description" />
      <meta content={resolvedKeywords} name="keywords" />
      <meta content="telephone=no" name="format-detection" />
      <meta content="default" name="referrer" />

      {/* Microsoft / PWA themed meta */}
      <meta content="#da532c" name="msapplication-TileColor" />
      <meta content={`${basePath}/favicon/browserconfig.xml`} name="msapplication-config" />
      <meta content="#ffffff" name="theme-color" />

      {/* Indexation contrôlée */}
      <meta content={noindex ? 'noindex, nofollow' : 'index, follow'} name="robots" />

      {/* Canonical link */}
      <link key="canonical" href={resolvedUrl} rel="canonical" />

      {/* OpenGraph Tags */}
      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={resolvedImage} property="og:image" />
      <meta content={resolvedUrl} property="og:url" />
      <meta content={type} property="og:type" />
      <meta content="zLawyer" property="og:site_name" />
      <meta content="fr_FR" property="og:locale" />

      {/* Twitter Card */}
      <meta content="summary_large_image" name="twitter:card" />
      <meta content={title} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content={resolvedImage} name="twitter:image" />

      {/* Favicon & App Icons */}
      <link href={`${basePath}/favicon.ico`} rel="icon" />
      <link
        href={`${basePath}/favicon/apple-touch-icon.png`}
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        href={`${basePath}/favicon/favicon-32x32.png`}
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href={`${basePath}/favicon/favicon-16x16.png`}
        rel="icon"
        sizes="16x16"
        type="image/png"
      />
      <link href={`${basePath}/favicon/site.webmanifest`} rel="manifest" />
      <link color="#5bbad5" href={`${basePath}/favicon/safari-pinned-tab.svg`} rel="mask-icon" />
      <link href={`${basePath}/favicon/favicon.ico`} rel="shortcut icon" />

    </Head>
    <Script id="elfsight" src="https://apps.elfsight.com/p/platform.js" strategy="lazyOnload" />
    </>
  );
};

export default SEO;
